













import {Component, Prop, Vue, Product, ComponentConfig} from "@zoovu/runner-browser-api";
import {ProductButtonConfiguration} from "../configuration";

@Component({})
export default class ProductClickoutLinkView extends Vue {

    @Prop()
    product: Product;

    @ComponentConfig(ProductButtonConfiguration)
    productButtonConfiguration: ProductButtonConfiguration;

    offerUrl: string = this.product.offerUrl;

    updateOfferUrl() {
        const trackedOfferUrl = this.product.getTrackedOfferUrl();
        this.offerUrl = trackedOfferUrl;
        (this.$refs.anchor as HTMLElement).setAttribute("href", trackedOfferUrl); //it is important to change link without waiting for vue next tick!
    }

    onLeftMouseDown() {
        this.product.notifyUserMovedToProductDetailsPage();
    }

    get openLinkInNewTab(): string {
        if(!this.productButtonConfiguration || typeof this.productButtonConfiguration.openProductLinkInNewTab
            === "undefined") return "_blank"
        return this.productButtonConfiguration.openProductLinkInNewTab ? "_blank" : "_self";
    }
}
